import { SUBSTATUS } from 'src/models/Substatus/Substatus'

export const getDefaultSubstatus = () => {
  return SUBSTATUS.TERM_OF_ACCEPTANCE
}
